var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDeliveryPathFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3333,
    cy: 10.8203,
    r: 10,
    fill: "#FFF3EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7641 11.7869L10.8874 16.6169C10.7241 16.7802 10.5024 16.8852 10.2691 16.8677C10.0358 16.8677 9.8141 16.7744 9.65077 16.6111L4.86743 11.7811L6.10993 10.5502L9.39993 13.8752V4.77523H11.1499V13.8869L14.5274 10.5444L15.7583 11.7869H15.7641Z",
    fill: "#FF7448"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDeliveryPathFill);
export default __webpack_public_path__ + "static/media/ic_delivery_path_fill.6f8fa271ebdf48d6e61b8ac16e67a84c.svg";
export { ForwardRef as ReactComponent };